import globalStore from '$$globalStore';

export default function () {
  if (globalStore.getters.isLink || globalStore.getters.isExport) {
    return user.settings.user_id;
  }
  return user.id;
}
